const menuSides = [
  {
    id: 1,
    name: "Hummus",
    description: [
      "Chickpeas blended with tahini sauce, garlic and lemon juice to a creamy perfection.",
      "Comes with Pita Bread Serves 2",
    ],
    price: "$7.26",
  },
  {
    id: 2,
    name: "Baba Dip",
    description: [
      "Roasted eggplant blended with tahini sauce, garlic, lemon juice and seasonings.",
      "Comes with Pita Bread Serves 2",
    ],
    price: "$7.78",
  },
  {
    id: 3,
    name: "Sarma",
    description: [
      "Vegetarian grape leaves stuffed with rice, parsley, tomatoes, and seasonings.",
    ],
    price: "$2.59",
  },
  {
    id: 4,
    name: "Falafel Balls",
    description: [
      "Ground chickpeas and fava beans, seasoned and fried to a crispy golden brown. ",
      "Comes with Tahini Sauce",
    ],
    price: "$1.30",
  },
  {
    id: 5,
    name: "French Fries",
    description: ["add a scoop of Tabbouli $1.00"],
    price: "$5.70",
  },
  {
    id: 6,
    name: "Side of Rice",
    description: [""],
    price: "$5.70",
  },
];

export default menuSides;
